
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as RegisterHugeGroupIconComponent } from "./register-huge-group-icon.svg";

export const RegisterHugeGroupIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <RegisterHugeGroupIconComponent {...props} />;
};
